export const InitialFactoryFormData = {
  name: "",
  address: "",
  email: "",
  phone: "",
  status: "",
};
export const InitialUserFormData = {
  name: "",
  role: "",
  factory: "",
  email: "",
  password: "",

  status: "",
};

export const InitialProductFormData = {
  name: "",
  quality: "",
  price: "",
  product: "",
  discount_amount: "",
  discount_type: "",
  effect_from: "",
  effect_to: "",
  status: "",
};

export const InitialVendorFormData = {
  name: "",
  type: "",
  address: "",
  contact_number: "",
  status: "",
};

//quality initial data start

export const InitialQualityFormData = {
  name: "",

  status: "",
};
//quality initial data end

//Sub Quality initial data start

export const InitialSubQualityFormData = {
  name: "",
  quality: "",
  status: "",
};

//Sub Quality initial data end

//labour cost inital data start
export const InitialLabourCostFormData = {
  job_title: "",
  no_staff: "",
  factory: "",
  average_salary: "",
  total_salary: "",
  effective_date: "",
};

//operator initial data end

export const InitialOperatorCostFormData = {
  name: "",
  factory: "",
  contact_number: "",
  status: "",
  address: "",
};

//operator initial data end

//leafWareHouse initial data end

export const InitialLeafWareHouseFormData = {
  name: "",
  address: "",
  contact_number: "",
  status: "",
};

//leafWareHouse initial data end

//CartoonType initial data end

export const InitialCartoonTypeFormData = {
  name: "",
  size: "",
  product: "",
  product_quantity_per_cartoon: "",
  status: "",
};

//CartoonType initial data end
//PlasticType initial data end

export const InitialPlasticTypeFormData = {
  name: "",
  weight_of_plastic_per_pack: "",

  product_quantity_per_plastic: "",
  weight_of_plastic_per_pices: "",
  product: "",
  type: "",
  status: "",
};

//PlasticType initial data end
export const InitialProductionFormData = {
  name: "",
  quality: "",
  price: "",
  discount_amount: "",
  discount_type: "",
  effect_from: "",
  effect_to: "",
  status: "",
};

//mold initial data end

export const InitialMoldFormData = {
  name: "",
  product: "",
  status: "",
};

//Mold initial data end
//cartoon stock initial data start
export const InitialCartoonStockFormData = {
  purchase_date: "",
  bill_number: "",
  vendor: "",
  cartoon_type: "",
  quantity: "",
  price_per_cartoon: "",
  paid_amount: "",

  total_amount: "",
};
//cartoon stock initial data end
//plastic stock initial data start
export const InitialPlasticStockFormData = {
  purchase_date: "",
  bill_number: "",
  vendor: "",
  plastic_type: "",
  quantity: "",
  price_per_plastic: "",
  paid_amount: "",

  total_amount: "",
};
//plastic stock initial data end

//leaf stock initial data start
export const InitialLeafStockFormData = {
  purchase_date: "",
  bill_number: "",
  buy_method: "",
  vendor: "",
  leaf_store_ware_house: "",
  quantity: "",
  price_per_leaf: "",
  paid_amount: "",
  mileage: "",
  overal_cost: "",
  distance_travel: "",
  hiring_cost: "",
};
//leaf stock initial data end
export const InitialStickerStockFormData = {
  bill_number: "",

  vendor_id: "",

  quantity: "",

  paid_amount: "",
  total_amount: "",
};

export const InitialCartoonWithDrawFormData = {
  product_id: "",
  product_qty: "",
  cartoon_qty: "",
  product_quality: "",
  production_date: "",
};

export const InitialPlasticWithDrawFormData = {
  product_id: "",
  product_qty: "",
  plastic_qty: "",
  product_quality: "",
  production_date: "",
};
